import { Box, Button, Typography, CircularProgress } from '@material-ui/core';
import { Mixpanel } from '../mixpanel';
import { RegularSizeValue, SizeType } from 'common-ts/dist/models/Cart';
import { BodyMeasurements, BodyMeasurementsKey, CalculateClothBodyMeasurementsFromBodyMeasurements, CalculateClothingMeasurementsFromBodyMeasurements, ClothingMeasurements, ClothingType, FitType, RoundClothingMeasurementsToHalfPoint, UserBodyMeasurements, UserClothTypeSpecificBodyMeasurements, getBodyCardFitFamily } from 'common-ts/dist/models/UserMeasurements';
import { inputBodyMeasurementsForm, inputMeasurementsForm, postBodyMeasurement, postClothingMeasurement, resetUserMeasurementDraft } from '../redux/MeasurementsRedux';
import { closeOverlayAndReset, setMeasurementObjectDraftValue } from '../redux/UIOverlayUniversalSizeCreateMeasRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import PersonalSizeUkurTiapBagianV2 from './OverlayViewUniversalSizeCreateMeas1UkurTiapBagian';
import OverlayViewSaveMeasName from './OverlayViewUniversalSizeCreateMeas2SaveScreen';
import OverlayViewBackToShop from './OverlayViewUniversalSizeCreateMeas3BackToShopScreen';
import OverlayViewFavoriteModifySize from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { useEffect, useState } from 'react';
import { openOverlay as openOverlayQRResult, setValues as setValuesQRResult } from '../redux/UIOverlayQRResultRedux';
import ProductOnUser from 'common-ts/dist/models/Product';
import PersonalSizeCheckAdjustSize from './OverlayViewUniversalSize5CheckSize';
import { closeOverlayAndReset as closeOverlayAndResetSelection } from '../redux/UIOverlayMeasurementSelectionViewRedux';
import { UkuranBadanSegment } from './PageProductDetailSizeOptions';
import PersonalSizeNeedToCreate from './OverlayViewUniversalSizeCreateMeas0NeedToComplete';
import { setValues as setValuesUnivSizeCreateView, openOverlay as openOverlayUnivSizeCreateView } from '../redux/UIOverlayUniversalSizeCreateMeasRedux';

import { openOverlay as openOverlayPersonalSizeDetail } from '../redux/UIOverlayPersonalSizeRedux';
import axios, { AxiosRequestConfig } from 'axios';

// Determines which flow is used based on starting parameters
export interface FlowSelectionData {
  editedSourceUserMeasurement: UserClothTypeSpecificBodyMeasurements | undefined
  sourceUserMeasurement: UserBodyMeasurements | UserClothTypeSpecificBodyMeasurements | undefined
  clothingType: ClothingType
  fitType: FitType
  productDetail?: ProductOnUser
  useDialog: boolean
  origin: 'default' | 'order' | 'qr',
  displayImagesArray: string[],
  missingMeas: string[],
}

// State data for flow
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateData {
  currentScreen: string
  titleNumber: number
  currentUserMeasurement: UserClothTypeSpecificBodyMeasurements
  currentUserBodyMeasurement: UserBodyMeasurements
  currentFlowData: any
}

// Callback to change state data for flow. 
// Only for UI state, currentUserMeasurement is accessed within component.
export interface FlowStateCallback {
  delayedDispatch: (currentScreen: string) => void
  setTitleNumber: (titleNumber: number) => void
  setCurrentFlowData: (updatedCurrentFlowData: any) => void
}

//
// RENDERER 
// Master function that is used to select and pass data to the block 
// selected using the flow selection data.
//
export function FlowComponentMasterPersonalSize(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  
  let children: JSX.Element[] = [];
  children = FlowComponentMensTops(flowSelectionData, flowStateData, flowStateCallback);
  
  // We choose the right block to use with the flow selection data.
  return (
    <Box>
      {
        children
      }
    </Box>
  );
}

export function LoadAndRequest({startingCallFunction}: {startingCallFunction: () => void}) {
  useEffect(() => {
    startingCallFunction();
  }, []);

  return (
    <Box style={{minHeight: '400px', minWidth: '300px', marginLeft: '-15px',
      display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <CircularProgress />
    </Box>
  );
}

function FlowComponentMensTops(flowSelectionData: FlowSelectionData, 
  flowStateData: FlowStateData, flowStateCallback: FlowStateCallback) {
  const dispatch = useAppDispatch();

  let titleNumber = -1;

  let delayedDispatch = flowStateCallback.delayedDispatch;

  let children: JSX.Element[] = [];

  const [measurementName, setMeasurementName] = useState(flowSelectionData.sourceUserMeasurement?.measurementName || 'Ukuran Custom')

  if (flowSelectionData.sourceUserMeasurement === undefined) {
    return children;
  }

  switch (flowStateData.currentScreen) {
    case "startComplete":
      children.push(
        <PersonalSizeNeedToCreate
          missingMeas={flowSelectionData.missingMeas}
          handleNext={() => {
            delayedDispatch("lengkapiUkuran");
          }}
        />
      )
      break;
    case "lengkapiUkuran":
      // Only used for panjang lengan panjang
      let plpLimits = [40, 60, 68];

      const leherValue = flowSelectionData.sourceUserMeasurement.adjustedMeasurements?.[BodyMeasurementsKey.lingkarLeher] ?? 0;

      // TODO Manually written here for fast response. Written down from user body meas.
      if (leherValue <= 37) {
        plpLimits = [40, 60, 68];
      } else if (leherValue <= 41) {
        plpLimits = [40, 62, 69];
      } else if (leherValue <= 45) {
        plpLimits = [40, 64, 70];
      }

        children.push(
          <Box style={{margin: '-8px 3px 0px'}}>
        <PersonalSizeUkurTiapBagianV2
      issues={['panjangLenganPanjang']}
      issuesLimits={{'panjangLenganPanjang': plpLimits}}
      clothingType={ClothingType.KemejaPanjang}
      fitType={FitType.RegularFit}
      userSelfInputMeasurements={{}}
      generatedMeasurements={{}}
      generatedMeasurementsRange={{}}
      generatedMeasurementsSafe={{}}
      handleBack={() => {
        delayedDispatch("startComplete");
      }}
      handleEachBack={(issues, newIssueIndex) => {
      }}
      handleEachSubmit={(issues, newIssueIndex, currentValue) => {
        dispatch(inputBodyMeasurementsForm({
          ...(flowSelectionData.sourceUserMeasurement as any),
          updateDateTime: new Date().toISOString(),
          adjustedMeasurements: {
            ...(flowSelectionData.sourceUserMeasurement as any).adjustedMeasurements,
            'panjangLenganPanjang': currentValue
          },
          // Pin the edited card to its own fit family (legacy cards = STANDARD). The draft
          // is merged (Object.assign), so a spread without fitType would let a leftover
          // value from an earlier edit in the same session survive.
          fitType: getBodyCardFitFamily(flowSelectionData.sourceUserMeasurement as UserBodyMeasurements),
        }));
      }}
      handleFinish={() => {
        dispatch(postBodyMeasurement({
          clothingType: flowSelectionData.clothingType,
          fitType: flowSelectionData.fitType,
          productDetail: flowSelectionData.productDetail
        }));
        dispatch(closeOverlayAndReset());
      }}/>
      </Box>);
      break;
    case "serviceabilityLoading":
      children.push(
        <LoadAndRequest startingCallFunction={() => {
          let config: AxiosRequestConfig = { }
    
          config = {
            method: 'post',
            url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/availability/meas-serviceable',
            data: JSON.stringify(
              {
                isFastServiceabilityCheck: true,
                measurements: flowSelectionData.sourceUserMeasurement?.adjustedMeasurements ?? {},
                productId: flowSelectionData?.productDetail?.productId,
              })
          };

          axios(config).then((response) => {
            if (response?.data?.additionalRequestResultData?.requireAdjustments === false) {
              delayedDispatch("editingScreen"); // Directly to size adjust
            } else {
              flowStateCallback.setCurrentFlowData((currentObj: any) => ({
                ...currentObj,
                neededModAdjustments: response.data.additionalRequestResultData.modAdjustments
              }));
              delayedDispatch("adjustServiceability"); // Need confirmation
            }
          });
        }}/>);
      break;
    case "adjustServiceability":
      children.push(<PersonalSizeCheckAdjustSize
        clothingType={flowSelectionData.clothingType}
        fitType={flowSelectionData.fitType}
        currentMeasurements={flowSelectionData.sourceUserMeasurement?.adjustedMeasurements as any}
        adjustedMeasurements={{
          ...flowSelectionData.sourceUserMeasurement?.adjustedMeasurements,
          ...flowStateData.currentFlowData.neededModAdjustments
        }}
        onBack={() => {
          dispatch(closeOverlayAndReset());
        }}
        onOk={() => {
          delayedDispatch("editingScreen");
        }}
      />);
      break;
    case "editingScreen":
      children.push(
        <>
          <Typography style={{margin: '0px 0px 10px 4px', fontWeight: 600}}>
            Pakai Size Card<sup>TM</sup> Kamu
          </Typography>
        </>
      )
      children.push(<UkuranBadanSegment
        clothingType={flowSelectionData.clothingType as ClothingType}
        fitType={flowSelectionData.fitType as FitType}
        productDetail={flowSelectionData?.productDetail}
        disableActions={true}
        singleSelectedBodyMeasurement={flowSelectionData.sourceUserMeasurement}
        singleSelectedBodyMeasurementCreationDateTime={flowSelectionData.sourceUserMeasurement?.creationDateTime ?? ''}
        closeParentFunction={() => {
          dispatch(closeOverlayAndReset());
          dispatch(closeOverlayAndResetSelection());
        }}
      />);
      const initialMeasurements = {
        ...flowSelectionData.sourceUserMeasurement?.adjustedMeasurements,
        ...flowStateData.currentFlowData.neededModAdjustments
      };
      children.push(<OverlayViewFavoriteModifySize
        showNumberOfSimiliarProduct={flowSelectionData.origin === 'qr'}
        numberOfSimiliarProduct={flowSelectionData.displayImagesArray.length}
        startingClothingBodyMeasurements={
          CalculateClothBodyMeasurementsFromBodyMeasurements(flowSelectionData.clothingType as ClothingType, 
            flowSelectionData.fitType as FitType, 
            initialMeasurements as any, RegularSizeValue.L, [])}
        startingClothingMeasurements={
          RoundClothingMeasurementsToHalfPoint(
          CalculateClothingMeasurementsFromBodyMeasurements(flowSelectionData.clothingType as ClothingType, 
            flowSelectionData.fitType as FitType, 
            initialMeasurements as any, RegularSizeValue.L))}
        editedClothingBodyMeasurements={
          flowSelectionData.editedSourceUserMeasurement ?
          CalculateClothBodyMeasurementsFromBodyMeasurements(flowSelectionData.clothingType as ClothingType, 
            flowSelectionData.fitType as FitType, 
            flowSelectionData.editedSourceUserMeasurement?.adjustedMeasurements as any, RegularSizeValue.L, [])
          :
          undefined
        }
        editedClothingMeasurements={
          flowSelectionData.editedSourceUserMeasurement ?
          RoundClothingMeasurementsToHalfPoint(
          CalculateClothingMeasurementsFromBodyMeasurements(flowSelectionData.clothingType as ClothingType, 
            flowSelectionData.fitType as FitType, 
            flowSelectionData.editedSourceUserMeasurement?.adjustedMeasurements as any, RegularSizeValue.L))
          :
          undefined
        }
        clothingType={flowSelectionData.clothingType as ClothingType}
        fitType={flowSelectionData.fitType as FitType}
        productId={ flowSelectionData?.productDetail?.productId }
        productDetail={ flowSelectionData?.productDetail }
        useSizeWheel={true}
        key2={flowSelectionData.clothingType + "-" + flowSelectionData.fitType}
        handleSubmit={(value, valueClothing) => {
          const currentTime = new Date().toISOString();

          let clothingBodyMeas: BodyMeasurements = value;
          let clothingMeas: ClothingMeasurements = valueClothing;
          const userMeasurementsInput: UserClothTypeSpecificBodyMeasurements = { 
            ...flowSelectionData.sourceUserMeasurement,
            bodyOrClothingMeasurements: "CLOTHING",
            sizeType: SizeType.personal,
            clothingType: flowSelectionData.clothingType as ClothingType,
            fitType: flowSelectionData.fitType as FitType,
            creationMethod: 'online-edit',
            caraBuatString: "Ubah Ukuran (Custom)",
            creationDateTime: currentTime,
            updateDateTime: currentTime,
            key1: undefined,
            key2: undefined,
            key3: undefined,
            key4: undefined,
            key12: undefined,
            key123: undefined,
            key234: undefined,
            key34: undefined,
            key1234: undefined,
          };

          userMeasurementsInput["clothingMeasurements"] = clothingMeas;
          userMeasurementsInput["generatedMeasurements"] = clothingBodyMeas;
          userMeasurementsInput["adjustedMeasurements"] = clothingBodyMeas;

          dispatch(inputMeasurementsForm(userMeasurementsInput));

          dispatch(setMeasurementObjectDraftValue({measurementObjectDraft: userMeasurementsInput}));

          delayedDispatch("nameScreen");
        }}
        allowSubmitWithoutChange={true}
        onlyUseServiceability={true}
        isMinimized={flowSelectionData.useDialog}
      />);
      titleNumber = 1;
      break;
    case "nameScreen":
      children.push(<OverlayViewSaveMeasName 
        showDisplayImagesArray={flowSelectionData.origin === 'order' || flowSelectionData.origin === 'qr'}
        displayImagesArray={flowSelectionData.displayImagesArray}
        clothingType={flowSelectionData.clothingType as ClothingType}
        fitType={flowSelectionData.fitType as FitType}
        key2={flowSelectionData.clothingType + "-" + flowSelectionData.fitType}
        clothingMeasurements={flowStateData.currentUserMeasurement.clothingMeasurements}
        startingName={flowSelectionData.sourceUserMeasurement?.measurementName ? flowSelectionData.sourceUserMeasurement.measurementName + '*' : 'Uk Custom'}
        handleSubmit={(measName) => {
          dispatch(inputMeasurementsForm({
            measurementName: measName
          }));

          setMeasurementName(measName)
          
          dispatch(postClothingMeasurement());

          switch (flowSelectionData.origin){
            case 'default':
              dispatch(closeOverlayAndReset());
              dispatch(closeOverlayAndResetSelection());
              delayedDispatch("editingScreen");
              break;
            case 'order':
              delayedDispatch("backToShopScreen");
              break;
            case 'qr':
              dispatch(setValuesQRResult({
                measurementName: measName,
                fitType: flowSelectionData.fitType as FitType,
                clothingType: flowSelectionData.clothingType as ClothingType,
                numberOfSimiliarProducts: flowSelectionData.displayImagesArray.length
              }))
              dispatch(openOverlayQRResult())
              dispatch(closeOverlayAndReset());
              break;
          }          
        }}
        handleBack={() => {
          delayedDispatch("editingScreen");
        }}
        isMinimized={flowSelectionData.useDialog}
        isAllowedBack={true}
      />);
      break;
    case "backToShopScreen":
      children.push(<OverlayViewBackToShop 
        clothingType={flowSelectionData.clothingType as ClothingType}
        fitType={flowSelectionData.fitType as FitType}
        key2={flowSelectionData.clothingType + "-" + flowSelectionData.fitType}
        clothingMeasurements={flowStateData.currentUserMeasurement.clothingMeasurements}
        measurementName={measurementName}
        handleSubmit={() => {
          dispatch(closeOverlayAndReset());
          delayedDispatch("editingScreen");
        }}
      />);
      break;
  }

  if (flowStateData.titleNumber != titleNumber) {
    flowStateCallback.setTitleNumber(titleNumber);
  }

  return children;
}